module.exports = __webpack_public_path__ + "img/15_dana_s.6668aab1.png";